import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailDetailDto, EmailService } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-email-detail-page',
  templateUrl: './email-detail-page.component.html',
  styleUrls: ['./email-detail-page.component.scss'],
})
export class EmailDetailPageComponent {

  isMultiple: boolean = true;

  form?: FormGroup;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly emailService: EmailService,
  ) {
    route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.emailService.findById(id).subscribe((email) => {
          email.htmlBody = this.addReturnUrlToPdfLinks(email.htmlBody, this.router.url);
          this.initForm(email);
          this.form?.disable();
        });
      } else {
        this.router.navigate(['emails']);
      }
    });
  }

  initForm(emailDto: EmailDetailDto) {
    this.form = new FormGroup({
      id: new FormControl(emailDto.id),
      subject: new FormControl(emailDto.subject),
      recipients: new FormControl(emailDto.recipients),
      ccRecipients: new FormControl(emailDto.cc),
      body: new FormControl(emailDto.htmlBody),
    });
    this.isMultiple = emailDto.recipients.length > 1;
  }

  private addReturnUrlToPdfLinks(html: string, returnUrl: string): string {
    if (!html) return html;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const anchors = Array.from(doc.querySelectorAll('a[href]')) as HTMLAnchorElement[];

    for (const a of anchors) {
      const href = a.getAttribute('href');
      if (!href) continue;

      try {
        const url = new URL(href, window.location.origin);
        if (url.pathname.startsWith('/pdf/') && !url.searchParams.has('returnUrl')) {
          url.searchParams.set('returnUrl', returnUrl);
          a.setAttribute('href', url.toString());
        }
      } catch {
        // ungültige URL im E-Mail-HTML — Link unverändert lassen
      }
    }

    return doc.body.innerHTML;
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['emails']);
  }
}
